export const useGoogleAdsTracking = () => {
  // Google Ads Conversion ID and Label for registration tracking
  const GOOGLE_ADS_CONVERSION_ID = 'AW-17215896823';
  const REGISTRATION_CONVERSION_LABEL = 'OHQBCJrv-fwaEPf5lpFA';
  
  const trackRegistrationComplete = () => {
    // Check if user comes from valid sources
    const referrer = document.referrer;
    const urlParams = new URLSearchParams(window.location.search);
    const hasGclid = urlParams.has('gclid'); // Google Ads traffic
    const isFromMangxo = referrer.includes('mangxo.com'); // Traffic from mangxo.com
    
    // Only track conversion if user comes from mangxo.com OR Google Ads
    if ((isFromMangxo || hasGclid) && window.gtag) {
      // Send conversion event when user successfully completes registration
      window.gtag('event', 'conversion', {
        'send_to': `${GOOGLE_ADS_CONVERSION_ID}/${REGISTRATION_CONVERSION_LABEL}`
      });
    }
  };

  return {
    trackRegistrationComplete
  };
};
